__turbopack_context__.v({
  "questionFormTextarea": "QuestionFormTextarea-module__GAg5FG__questionFormTextarea",
  "questionFormTextareaIcon": "QuestionFormTextarea-module__GAg5FG__questionFormTextareaIcon",
  "questionFormTextareaIconSaved": "QuestionFormTextarea-module__GAg5FG__questionFormTextareaIconSaved",
});
